/* @flow */

import * as types from './supportContactActionTypes';

import { supportContactEndpoint } from 'src/shared/app/base/settings/endpointSettings';

import type { Action, Thunk } from 'src/shared/core/type/reduxTypes';

export function contactSupport(data: Object, eventId: number): Thunk<void> {
  return (dispatch, { smartPost }) => {
    dispatch(contactSupportRequest());

    return smartPost(supportContactEndpoint(eventId), data)
      .then(() => dispatch(contactSupportSuccess()))
      .catch((exception) => {
        dispatch(contactSupportFailure(exception));

        throw exception;
      });
  };
}

export function contactSupportRequest(): Action {
  return {
    type: types.CONTACT_SUPPORT_REQUEST,
  };
}

export function contactSupportFailure(exception: Error): Action {
  return {
    type: types.CONTACT_SUPPORT_FAILURE,
    exception,
  };
}

export function contactSupportSuccess(): Action {
  return {
    type: types.CONTACT_SUPPORT_SUCCESS,
  };
}

export function resetContactSupport(): Action {
  return {
    type: types.RESET_CONTACT_SUPPORT,
  };
}
